import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import htmlToPdfmake from 'html-to-pdfmake';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { UserDatePipe } from '../../../../../shared/pipes/user-date.pipe';
@Component({
  selector: 'app-print-datasheet',
  standalone: true,
  imports: [CommonModule, UserDatePipe],
  templateUrl: './print-datasheet.component.html',
  styleUrl: './print-datasheet.component.scss',
})
export class PrintDatasheetComponent implements OnDestroy {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sheetData: any = null;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  @Input() set dataSheetData(val: any) {
    this.sheetData = val;
    this.cd.detectChanges();
    this.initialized = true;
  }
  @ViewChild('pdfContent', { static: true }) pdfContent!: ElementRef;
  initialized = false;
  private readonly destroy$ = new Subject<void>();
  constructor(private cd: ChangeDetectorRef) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async printPDF() {
    if (this.sheetData) {
      const pdfContent = document.getElementById('pdf-data');
      if (pdfContent) {
        const pdfMakeContent = htmlToPdfmake(pdfContent.innerHTML);
        const documentDefinition: TDocumentDefinitions = {
          content: pdfMakeContent,
          pageMargins: [20, 20, 20, 20],
          footer: function (currentPage: number) {
            return {
              columns: [
                { text: '', alignment: 'left' },
                {
                  text: `Powered by Insights to Behavior®`,
                  alignment: 'center',
                },
                { text: `${currentPage}`, alignment: 'right' },
              ],
              margin: [15, 0, 10, 0],
              color: '#475467',
            };
          },
          styles: {
            desc: { fontSize: 12 },
            address: { fontSize: 12 },
            title: { fontSize: 12 },
            datalabel: { color: '#475467' },
            dataValue: { color: '#475467' },
          },
          defaultStyle: {
            columnGap: 10,
            fontSize: 10,
          },
        };

        // Generate and download the PDF
        pdfMake
          .createPdf(documentDefinition)
          .download(
            `Datasheet_${this.sheetData.datasheetInfo.title}_${this.sheetData?.caseDetail.student.firstName} ${this.sheetData?.caseDetail.student.lastName}.pdf`
          );

        this.initialized = false;
        this.ngOnDestroy();
      }
    }
  }

  generateLI(item: any) {
    return JSON.stringify({
      listType: 'none',
      margin: [0, 0, 0, 0],
      columns: [
        {
          width: '*',
          fontSize: 10,
          lineHeight: 1.5,
          color: '#475467',
          text: item,
          margin: [0, 0, 0, 0],
        },
      ],
    });
  }

  generateTable(sheetData: any) {
    if (!sheetData || !Array.isArray(sheetData.timeSlots)) {
      return JSON.stringify({ text: 'No data available', alignment: 'center' });
    }

    return JSON.stringify({
      table: {
        headerRows: 1,
        widths: ['20%', '16%', '16%', '16%', '16%', '16%'], // 30% first column
        body: [
          // Table Header
          [
            {
              text: '',
              bold: true,
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true], // Ensure all borders are applied
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
            },
            {
              text: 'Monday',
              bold: true,
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true], // Ensure all borders are applied
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'], // Custom border colors
              fontSize: 10,
              lineHeight: 1.5,
              color: '#475467',
            },
            {
              text: 'Tuesday',
              bold: true,
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true], // Ensure all borders are applied
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'], // Custom border colors
              fontSize: 10,
              lineHeight: 1.5,
              color: '#475467',
            },
            {
              text: 'Wednesday',
              bold: true,
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true], // Ensure all borders are applied
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'], // Custom border colors
              fontSize: 10,
              lineHeight: 1.5,
              color: '#475467',
            },
            {
              text: 'Thursday',
              bold: true,
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true], // Ensure all borders are applied
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'], // Custom border colors
              fontSize: 10,
              lineHeight: 1.5,
              color: '#475467',
            },
            {
              text: 'Friday',
              bold: true,
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true], // Ensure all borders are applied
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'], // Custom border colors
              fontSize: 10,
              lineHeight: 1.5,
              color: '#475467',
            },
          ],

          // Table Data
          ...sheetData.timeSlots.map((timeSlot: any) => [
            {
              text: `${timeSlot?.startTime || 'N/A'} - ${timeSlot?.endTime || 'N/A'}`,
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],

              fontSize: 10,
              lineHeight: 1.5,
              color: '#475467',
            },
            {
              text: '',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],

              fontSize: 10,
              lineHeight: 1.5,
              color: '#475467',
            },
            {
              text: '',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],

              fontSize: 10,
              lineHeight: 1.5,
              color: '#475467',
            },
            {
              text: '',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],

              fontSize: 10,
              lineHeight: 1.5,
              color: '#475467',
            },
            {
              text: '',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],

              fontSize: 10,
              lineHeight: 1.5,
              color: '#475467',
            },
            {
              text: '',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],

              fontSize: 10,
              lineHeight: 1.5,
              color: '#475467',
            },
          ]),

          // Blank Row with Increased Height
          [
            {
              text: '\n',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
            },
            {
              text: '\n',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
            },
            {
              text: '\n',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
            },
            {
              text: '\n',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
            },
            {
              text: '\n',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
            },
            {
              text: '\n',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
            },
          ],

          // Total Row
          [
            {
              text: 'Total',
              bold: true,
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
              fontSize: 10,
              lineHeight: 1.5,
              color: '#475467',
            },
            {
              text: '',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
            },
            {
              text: '',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
            },
            {
              text: '',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
            },
            {
              text: '',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
            },
            {
              text: '',
              alignment: 'center',
              margin: [0, 7, 0, 7],
              border: [true, true, true, true],
              borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
            },
          ],
        ],
      },
      layout: {
        hLineColor: function () {
          return '#eaecf0';
        }, // Horizontal border color
        vLineColor: function () {
          return '#eaecf0';
        }, // Vertical border color
        hLineWidth: function () {
          return 1;
        }, // Thickness of horizontal lines
        vLineWidth: function () {
          return 1;
        }, // Thickness of vertical lines
      },
      margin: [0, 0, 0, 0],
    });
  }

  generateaPartialTable() {
    const tableHeader = [
      {
        text: 'Interval',
        bold: true,
        alignment: 'center',
        margin: [0, 3, 0, 3],
        border: [true, true, true, true],
        borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
        fontSize: 10,
        lineHeight: 1,
        color: '#475467',
      },
      ...Array.from({ length: 10 }, (_, i) => ({
        text: `${i + 1}`,
        bold: true,
        alignment: 'center',
        margin: [0, 3, 0, 3],
        border: [true, true, true, true],
        borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
        fontSize: 10,
        lineHeight: 1,
        color: '#475467',
      })),
      {
        text: 'Total',
        bold: true,
        alignment: 'center',
        margin: [0, 3, 0, 3],
        border: [true, true, true, true],
        borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
        fontSize: 10,
        lineHeight: 1,
        color: '#475467',
      },
    ];

    const tableBody = [
      tableHeader,
      ...Array.from({ length: 3 }, (_, rowIndex) => [
        {
          text: `Interval ${rowIndex + 1}`,
          alignment: 'center',
          margin: [0, 3, 0, 3],
          border: [true, true, true, true],
          borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
          fontSize: 10,
          lineHeight: 1,
          color: '#475467',
        },
        ...Array.from({ length: 10 }, () => ({
          text: '',
          alignment: 'center',
          margin: [0, 3, 0, 3],
          border: [true, true, true, true],
          borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
          fontSize: 10,
          lineHeight: 1,
          color: '#475467',
        })),
        {
          text: '',
          alignment: 'center',
          margin: [0, 3, 0, 3],
          border: [true, true, true, true],
          borderColor: ['#eaecf0', '#eaecf0', '#eaecf0', '#eaecf0'],
        },
      ]),
    ];

    return JSON.stringify({
      table: {
        headerRows: 1,
        widths: ['15%', ...Array(10).fill('7%'), '15%'], // Dynamic width
        body: tableBody,
      },
      layout: {
        hLineColor: function () {
          return '#eaecf0';
        }, // Horizontal border color
        vLineColor: function () {
          return '#eaecf0';
        }, // Vertical border color
        hLineWidth: function () {
          return 1;
        }, // Thickness of horizontal lines
        vLineWidth: function () {
          return 1;
        }, // Thickness of vertical lines
      },
      margin: [0, 0, 0, 0], // Adds spacing
    });
  }
}
